import { InfoButton, InformationTooltipMobile } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Rubrics.css';
import { RubricItem } from './components/RubricItem';
import { trackMobwebBurgerMortgageMainShow } from '../../../../containers/MobileNavigationContainer/containers/RubricsContainer/tracking';
import { useIntersectionVisibleOnce } from '../../../../hooks/useIntersectionVisibleOnce';
import { TIrLink } from '../../../../types/irLink';
import { IRubricsLinksState } from '../../../../types/rubricsLinks';
import { ISpecialPromo } from '../../../../types/specialPromos';

interface IRubricsProps {
  rubrics: { title: string; url: string | null; key: keyof IRubricsLinksState; isHidden?: boolean }[];
  specialPromo?: ISpecialPromo | null;
  irLink: TIrLink | null;
  onRubricClick(rubricKey: keyof IRubricsLinksState | 'investors'): void;
  onSpecialPromoCLick(): void;
}

function MobileRubricRow({
  title,
  rubricKey,
  url,
  isHidden,
  onRubricClick,
}: {
  title: string;
  rubricKey: keyof IRubricsLinksState;
  url: string | null;
  isHidden?: boolean;
  onRubricClick(key: keyof IRubricsLinksState | 'investors'): void;
}) {
  const isMortgageRubric = rubricKey === 'mortgage' || rubricKey === 'mortgageBrokerPromo';
  const mortgageShowRef = useIntersectionVisibleOnce(trackMobwebBurgerMortgageMainShow, {
    enabled: isMortgageRubric && Boolean(url),
  });

  if (isHidden) {
    return null;
  }

  return (
    <li ref={isMortgageRubric ? mortgageShowRef : undefined} className={styles['rubric-item']}>
      <RubricItem href={url as string} onClick={() => onRubricClick(rubricKey)}>
        {title}
      </RubricItem>
    </li>
  );
}

export const Rubrics: React.FC<IRubricsProps> = ({
  rubrics,
  specialPromo,
  irLink,
  onRubricClick,
  onSpecialPromoCLick,
}) => {
  return (
    <ul className={styles['container']}>
      {rubrics.map(({ title, key, url, isHidden }) => (
        <MobileRubricRow
          key={key}
          rubricKey={key}
          title={title}
          url={url}
          isHidden={isHidden}
          onRubricClick={onRubricClick}
        />
      ))}
      {specialPromo && (
        <li data-name={'MobileSpecialPromoItem'} className={styles['rubric-item']}>
          <RubricItem href={specialPromo.mobileUrl} onClick={onSpecialPromoCLick}>
            <div className={styles['special-promo-item']}>
              <span>Новостройки от {specialPromo.nameGenitive}</span>
              {specialPromo.mobileLogoUrl && (
                <div
                  className={styles['special-promo-item-logo']}
                  style={{ backgroundImage: `url("${specialPromo.mobileLogoUrl}")` }}
                />
              )}
            </div>
          </RubricItem>
          {specialPromo.disclaimer && (
            <InformationTooltipMobile
              content={
                <div className={styles['tooltip-container']}>
                  <InfoButton />
                  <div>{specialPromo.disclaimer}</div>
                </div>
              }
              portal={false}
            >
              <InfoButton data-name={'MobileSpecialPromoItemHint'} />
            </InformationTooltipMobile>
          )}
        </li>
      )}
      {irLink && (
        <li data-name="IrLink" key={irLink.key} className={styles['rubric-item']}>
          <RubricItem key={`rubric_${irLink.title}`} href={irLink.link} onClick={() => onRubricClick(irLink.key)}>
            {irLink.title}
          </RubricItem>
        </li>
      )}
    </ul>
  );
};
